import { formatToCurrency } from '@betgames/bg-tools';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { formatToUserCurrency } from '@bg-shared/utils/formatToUserCurrency';

export const formatToFreePlayCurrency = (currencyCode: string, amount: number) => {
    const { currency } = partnerSettingsStore;

    if (!currencyCode) {
        return null;
    }

    if (currencyCode.toLowerCase() === currency.code.toLowerCase()) {
        return formatToUserCurrency(amount);
    }

    return formatToCurrency(amount, 2, `X${currencyCode}`);
};
